//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
let d=[[],[[["runId"],"GetRefreshStatusForRun",{R_:{refreshStatus:''}},1,0],[["runId"],"GetBlockedReasonForRun",{R_:{blockedReason:''}},1,0],[["runId"],"GetTimestampOfRefreshedRun",{R_:{timestamp:''}},1,0]],[]];
SPLM.MechanicalRouting.RefreshRunsFromTeamcenterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.RefreshRunsFromTeamcenterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.RefreshRunsFromTeamcenterBuilder.RefreshStatusType = Object.freeze({
    "Unknown" : "Unknown", "UpToDate" : "UpToDate", "Refreshed" : "Refreshed", "Blocked" : "Blocked", "Deleted" : "Deleted", "Failed" : "Failed"});

SPLM.MechanicalRouting.RefreshRunsFromTeamcenterBuilder.BlockedReasonType = Object.freeze({
    "NotBlocked" : "NotBlocked", "LoadedInPid" : "LoadedInPid", "OtherRunsBlocked" : "OtherRunsBlocked", "NotSpecified" : "NotSpecified"});

export default SPLM;